import { render, staticRenderFns } from "./informations.vue?vue&type=template&id=1f5a9595"
import script from "./informations.vue?vue&type=script&lang=js"
export * from "./informations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports